module.exports = __webpack_public_path__ + "img/logo_g.9ca14a9b.svg";